import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrcamentosEPacotesEditarRoutingModule } from './orcamentos-e-pacotes-editar-routing.module';
import { OrcamentosEPacotesEditarComponent } from './orcamentos-e-pacotes-editar.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';


@NgModule({
  declarations: [
    OrcamentosEPacotesEditarComponent
  ],
  imports: [
    CommonModule,
    OrcamentosEPacotesEditarRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DividerModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    ProgressSpinnerModule,
    DialogModule,
    TooltipModule,
    MessagesModule,
    ConfirmDialogModule,
    FormatPipeModule
  ],
  providers: [ConfirmationService]
})
export class OrcamentosEPacotesEditarModule { }
